export enum JetsonHealthStatus {
  RUNNING = 'RUNNING',
  UP = 'UP',
  DOWN = 'DOWN',
  UNKNOWN = 'UNKNOWN',
  OUT_OF_SERVICE = 'OUT_OF_SERVICE',
  CAMERA_CONNECTION_ERROR = 'CAMERA_CONNECTION_ERROR',
}

export const statusToMessageMap = {
  [JetsonHealthStatus.RUNNING]: { message: 'Resetting', status: 'issue' },
  [JetsonHealthStatus.UP]: { message: 'Healthy', status: 'up' },
  [JetsonHealthStatus.DOWN]: { message: 'Connection Lost', status: 'down' },
  [JetsonHealthStatus.UNKNOWN]: { message: 'Connection Lost', status: 'down' },
  [JetsonHealthStatus.OUT_OF_SERVICE]: {
    message: 'Out of Service',
    status: 'down',
  },
  [JetsonHealthStatus.CAMERA_CONNECTION_ERROR]: {
    message: 'Camera Connection Error',
    status: 'issue',
  },
};
